import React, { Component } from 'react';
import { IonCard } from '@ionic/react';
import getType from '../../../pages/Menu/GetDataType';
import HtmlParseComponent from '../../../pages/Menu/htmlParsingComponent';
import { Accordion } from './Accordion';
import { createStructuredSelector } from 'reselect';
import { makeSubmitFeedback } from '../../../selectors/Menu/selector';
import { getLoading, getNetworkStatus, getUserMasterData } from '../../../selectors/selector';
import { showNetworkAlert } from '../../../actions/App/action';
import { connect } from 'react-redux';
import { submitFeedback } from '../../../actions/Menu/action';
import useInjectSaga from '../../../utils/injectSaga';
import useInjectReducer from '../../../utils/injectReducer';
import reducer from '../../../reducers/Menu/reducer';
import saga from '../../../saga/Menu/saga';
import { compose } from 'redux';
const key = 'Menu';

class MenuDetailsPage extends Component<any, any> {

  render() {
    let contextData;
    let type: any;
    const entries = this.props && this.props.subMenuDetails;
    if (entries && entries.sections) {
      contextData = entries.sections;
      type = getType(entries.dataTypes, 'sections');
    } else if (entries && entries.group) {
      contextData = entries.group;
      type = getType(entries.dataTypes, 'group');
    }
    return (
      <>
        {entries && entries.richText ? (
          <HtmlParseComponent
            richText={entries.richText}
            isRichText={true}
          />
        ) : (
          contextData &&
          contextData.map((detailList: any, index: number) => (
            <IonCard key={index} class="ion-card" className={"menu-details-card"}>
              <Accordion contextData={detailList} dataType={type} accordProps = {this.props} />
            </IonCard>
          ))
        )}
      </>
    );
  }
}
const mapStateToProps = createStructuredSelector({
  submitFeedbackCall: makeSubmitFeedback(),
  userDetails: getUserMasterData(),
  isLoading: getLoading(),
  isNetworkAvailable: getNetworkStatus()
});

export const mapDispatchToProps = (dispatch: Function) => ({
  submitFeedback: (data: any, callback: Function) => dispatch(submitFeedback(data, callback)),
  showAlert: () => dispatch(showNetworkAlert())
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withReducer = useInjectReducer({ key, reducer });
const withSaga = useInjectSaga({ key, saga });

export default compose<any>(withConnect, withReducer, withSaga)(React.memo(MenuDetailsPage));
